export class ObjectCleaner {
  static removeEmptyProperties(obj: any) {
    const result = Object.keys(obj)
      .filter(key => obj.hasOwnProperty(key)) // convert to key value list
      .map(key => ({ key: key, value: obj[key] })) // skip empty fields
      .filter(kv => kv.value !== '' && kv.value !== null && kv.value !== undefined) // convert back to object map
      .reduce((qParams: any, kv) => {
        qParams[kv.key] = kv.value;
        return qParams;
      }, {});
    return result;
  }
}
